<template>
    <div>
        <div class="titre contour_texte_interventions">Projets</div>
        <div class="container_volet interventions" @scroll="checkScroll">
             <div class="excel">
                <a :href="url_excel" target="_blank">TÉLÉCHARGER AU FORMAT EXCEL</a>
            </div>
            <table class="tableau">
                <thead>
                    <tr>
                        <template v-if="$mq == 'mobile'">
                            <th v-for="colonne in colonnes" :key="colonne.slug" :style="{width: colonne.largeur_mobile}" v-if="colonne.mobile">
                                <span :class="{triable : colonne.tri}" @click="modifier_tri(colonne.slug)" :id="'colonne-' + colonne.slug">
                                    {{ colonne.nom }} 
                                    <template v-if="colonne.tri">
                                        <template v-if="colonne.ordre == 'desc'">↓</template>
                                        <template v-else>↑</template>
                                    </template>
                                </span>
                            </th>
                        </template>

                        <template v-else>
                            <th v-for="colonne in colonnes" :key="colonne.slug" :style="{width: colonne.largeur}">
                                <span :class="{triable : colonne.tri}" @click="modifier_tri(colonne.slug)" :id="'colonne-' + colonne.slug">
                                    {{ colonne.nom }} 
                                    <template v-if="colonne.tri">
                                        <template v-if="colonne.ordre == 'desc'"><span class="desc">↓</span></template>
                                        <template v-else><span class="asc">↑</span></template>
                                    </template>
                                </span>
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="fiche in fiches_triees" :key="fiche.id" @click="fermerVoletBas(), $router.push(url_base+'interventions/'+fiche.slug)" :id="'intervention-' + fiche.id" class="intervention">
                        <td v-for="colonne in colonnes" :key="colonne.slug" @mouseover="afficher_etiquette($event)" v-if="$mq != 'mobile' || colonne.mobile">
                        
                            <template v-if="colonne.slug == 'fonctions'">
                                {{ retour_fonctions(fiche['acteurs']) }}
                            </template>
                            <template v-else-if="colonne.slug == 'budget'">
                                {{ retour_budget(fiche[colonne.slug]) }}
                            </template>
                            <template v-else-if="colonne.slug == 'duree'">
                                {{ retour_duree(fiche[colonne.slug]) }}
                            </template>
                            <template v-else-if="colonne.slug == 'lieu_references'">
                                <!-- <div v-for="place in fiche[colonne.slug]">{{ place.name }}</div> -->
                                {{ retour_lieu_references(fiche[colonne.slug]) }}
                            </template>
                            <template v-else>
                                <template v-if="fiche[colonne.slug] != ''">
                                    {{ fiche[colonne.slug] }}
                                </template>
                                <template v-else>
                                    &mdash;
                                </template>
                            </template>
                        
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="etiquette_contenu"></div>
    </div>
</template>

<script>

/* {
                    "slug": "lieu_abrege",
                    "nom": "Lieu",
                    "tri": "inactif",
                    "ordre": "desc",
                    "largeur": "10%",
                    "largeur_mobile": "10%",
                    "mobile": false
                }, */
var prevY = 0;

import { state } from '../../main.js';
import { url_base, url_excel } from '../../variables.js'
import _ from 'lodash'

export default {
    data() {
        return {
            url_base: url_base,
            url_excel: url_excel,
            fiches: state.fiches,
            acteurs: state.acteurs,
            fonctions: state.fonctions,
            fonctions_par_id: state.fonctions_par_id,
            acteurs_par_id: state.acteurs_par_id,
            colonnes: [{
                    "slug": "categorie",
                    "nom": "Catégorie",
                    "tri": "actif",
                    "ordre": "asc",
                    "largeur": "178px",
                    "largeur_mobile": "178px",
                    "mobile": true
                }, {
                    "slug": "titre",
                    "nom": "Titre",
                    "tri": "inactif",
                    "ordre": "desc",
                    "largeur": "20%",
                    "largeur_mobile": "auto",
                    "mobile": true
                }, {
                    "slug": "objet",
                    "nom": "Objet",
                    "tri": false,
                    "largeur": "15%",
                    "largeur_mobile": "15%",
                    "mobile": false
                }, {
                    "slug": "fonctions",
                    "nom": "Fonctions des acteurs",
                    "tri": false,
                    "largeur": "20%",
                    "largeur_mobile": "20%",
                    "mobile": false
                }, {
                    "slug": "budget",
                    "nom": "Budget",
                    "tri": "inactif",
                    "ordre": "desc",
                    "largeur": "110px",
                    "largeur_mobile": "110px",
                    "mobile": false
                }, {
                    "slug": "annee",
                    "nom": "Année",
                    "tri": "inactif",
                    "ordre": "desc",
                    "largeur": "60px",
                    "largeur_mobile": "60px",
                    "mobile": true
                }, {
                    "slug": "duree",
                    "nom": "Durée",
                    "tri": "inactif",
                    "ordre": "desc",
                    "largeur": "60px",
                    "largeur_mobile": "60px",
                    "mobile": false
                },{
                    "slug": "lieu_references",
                    "nom": "Lieu",
                    "tri": "inactif",
                    "ordre": "desc",
                    "largeur": "10%",
                    "largeur_mobile": "10%",
                    "mobile": false
                }

            ]
        }
    },


    computed: {

        fiches_triees: function() {
            var liste_fiches = Object.values(this.fiches);
            var tri, ordre;
            for (var i = 0; i < this.colonnes.length; i++) {
                let colonne = this.colonnes[i];
                if (colonne.tri == "actif") {
                    tri = colonne.slug;
                    ordre = colonne.ordre;
                    break;
                }
            }
            liste_fiches = _.orderBy(liste_fiches, tri, ordre);
            //console.log(liste_fiches);
            return liste_fiches;
        }

        
    },

    methods: {
        checkScroll(e){
            var y = document.getElementsByClassName("interventions")[0].scrollTop;
            if(y >= prevY){
                if(document.getElementsByClassName("volet_bas")[0].classList.contains("reduced")){}else{
                    document.getElementsByClassName("volet_bas")[0].classList.add("reduced");
                }
            }else{
                document.getElementsByClassName("volet_bas")[0].classList.remove("reduced");
            }
            document.getElementById("volet_bas-banner").setAttribute("data-state","close");
            prevY = y;
        },
        fermerVoletBas : function(){
            document.getElementById("banner-title").parentElement.setAttribute("data-state","close");
        },
        afficher_etiquette: function(event) {
            if(window.innerWidth > 750){
                let texte = event.srcElement.innerHTML;

                if (event.srcElement.scrollWidth >  $(event.srcElement).innerWidth()) {
                    // let pos_x = $(event.srcElement).offset().left;
                    // let pos_y = $(event.srcElement).offset().top;

                    let pos_x = event.srcElement.getBoundingClientRect().left
                    let pos_y = event.srcElement.getBoundingClientRect().top

                    $(".etiquette_contenu").css({
                        'top': pos_y,
                        'left': pos_x
                    });
                    $(".etiquette_contenu").show();
                    $(".etiquette_contenu").html(texte);
                } else {
                    $(".etiquette_contenu").hide()
                }
            }
        },
        retour_fonctions: function(id_acteurs) {
            if (id_acteurs != '') {
                var retour_fonctions = "";
                let fonctions_projet = [];

                for (var i=0; i<id_acteurs.length; i++) {
                    let fonctions_acteur = this.acteurs_par_id[id_acteurs[i]].fonctions;

                    for (var j=0; j<fonctions_acteur.length; j++) {
                        fonctions_projet.push(fonctions_acteur[j]);
                    }
                }

                fonctions_projet = uniq(fonctions_projet);
                
                for (var i=0; i<fonctions_projet.length; i++) {
                    retour_fonctions += this.fonctions_par_id[fonctions_projet[i]] + ", ";
                }

                return retour_fonctions.slice(0, -2); //
            } else {
                return '—';
            }
        },
        retour_lieu_references: function(liste) {
            if(liste){
                //console.log("there is a ",liste);
                if(liste.length > 0){
                    if(liste.length > 1){
                        var str = "";
                        for(var a = 0; a < liste.length; ++a){
                            var sup = "; \n";
                            if(a >= liste.length-1){ sup = ""; }
                            str += liste[a]["name"] + sup;                     
                        }
                        return str;
                    }else{
                        return liste[0]["name"];
                    }
                }else{
                    return "—";
                }
            }else{
                //console.log("no list",liste);
            }
        },
        retour_budget: function(budget) {
            if (budget != 0) {
                return parseInt(budget).toLocaleString()+" euros";
            } //else {
            //     return "—"; 
            // }
        },
        retour_duree: function(jours) {
            if (jours != 0) {
                if (jours > (365*1.5)) {
                    return Math.round((jours/365))+" ans";
                } else if (jours > 365) {
                    return Math.round((jours/365))+" an";
                } else if (jours > 32) {
                    return Math.round((jours/31))+" mois";
                } else {
                    return Math.round(jours) +" jours";
                }
            } else {
                return "—"; 
            }
        },
        modifier_tri(slug) {
            for (var i = 0; i < this.colonnes.length; i++) {
                let colonne = this.colonnes[i];
                if (colonne.slug == slug && colonne.tri != false) {

                    if (colonne.tri == "inactif") {
                        for (var j = 0; j < this.colonnes.length; j++) {
                            if (this.colonnes[j].tri == "actif") {
                                this.colonnes[j].tri = "inactif";
                            }
                        }
                        colonne.tri = "actif"
                    } else {
                        if (colonne.ordre == "desc") {
                            colonne.ordre = "asc"
                        } else {
                            colonne.ordre = "desc"
                        }
                    }

                    break;
                }
            }
        }
        // chercherObjets() {
        //     this.axios.get(url_base).then((response) => {
        //         for (var i=0; i<response.data.records.length; i++) {
        //             let objet = response.data.records[i];
        //             objet.afficher_annee = true;
        //             objet.afficher_recherche = true;
        //             objet.afficher_type = true;
        //             this.$set(state.objets, objet.aa_inventory_number, objet);
        //         }
        //     });
        // }
    }
};

function uniq(a) {
    return a.sort().filter(function(item, pos, ary) {
        return !pos || item != ary[pos - 1];
    });
}



//window.addEventListener("scroll",checkScroll);

/*function checkScroll(e) {
    var currentScrollPos = window.pageYOffset;
    console.log(e);
    if(prevScrollpos > currentScrollPos){
        //document.getElementById("volet_bas").style.top = "0";
    } else {
        //document.getElementById("volet_bas").style.top = "-50px";
    }
    prevScrollpos = currentScrollPos;
}*/

/*problemata scroll header*/
//checkScroll();
function checkScrollPBTA(e){
    //console.log(window.scrollY);
    if(window.scrollY > 0){
        /*if(document.body.classList.contains('headerontop')){
            document.body.classList.remove('headerontop');
        }else{}

        if(document.body.classList.contains('headerreduced')){}else{
            document.body.classList.add('headerreduced');
        }
        }else{

        if(document.body.classList.contains('headerreduced')){
            document.body.classList.remove('headerreduced');
        }else{}*/
    }
}
</script>
<style>

.contour_texte_interventions {
    text-shadow:
        -2px -2px 0 var(--couleur-interventions),
        2px -2px 0 var(--couleur-interventions),
        -2px 2px 0 var(--couleur-interventions),
        2px 2px 0 var(--couleur-interventions);
}

.interventions {
    background-color: var(--couleur-interventions);
    padding-bottom:200px;
    /*width: calc(100vw - (36px * 4))!important;*/
    /*width: calc(100% - (39px * 0))!important;*/
    width: calc(100vw - (39px * 4))!important;
}

.tableau {
    position: relative;
    margin-left: var(--tbm);
    margin-top: 100px;
    width: calc(100% - var(--tbm)*2.5);
    table-layout: fixed;
    font-size: var(--corps-petit);
    line-height: var(--interlignage-petit);
}

tbody > tr {
    height: 1.7em;
    vertical-align: bottom;
}
tbody > tr:hover {
    background-color:rgba(0,0,0,0.1);
    cursor:pointer;
}

tbody>tr:first-child {
    border-top: 1.5px solid black;
    /*height: 25px;*/
}

th {
    text-align: left;
    border-collapse: separate;
    height: 30px;
}


td {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    /*border:1px solid red;*/
    vertical-align: text-bottom;
    padding-top:4px;
}


.triable {
    cursor: pointer;
}

.etiquette_contenu {
    position: absolute;
    z-index:3;
    top:100px;
    left:100px;
    font-size: var(--corps-petit);
    line-height: var(--interlignage-petit);
    white-space: normal;
    max-width:350px;
    background-color: var(--couleur-interventions);
    border:1.5px solid black;
    /*padding-top: 6px;
    padding-bottom: 2px;*/
    padding-top:5px;
    padding-bottom:3px;
    padding-left: var(--tbm);
    padding-right: var(--tbm);
    margin-top:-2px;
    margin-left:-118px;
    pointer-events: none;
}

.excel {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 3;
    background-color: transparent;
}

</style>